"use client";

import { useState } from "react";
import { PROCESS, SECTION_IDS } from "./content";
import { cn } from "@/app/utils/className";

export const HowWeWork = () => {
  const [active, setActive] = useState(0);

  return (
    <section
      id={SECTION_IDS.process}
      className="dc-section border-t border-white/[.07] bg-ink-2"
    >
      <div className="dc-shell">
        <h2 className="mt-0 mb-[clamp(48px,6vw,84px)] max-w-[16ch] text-[clamp(34px,5vw,82px)] font-bold leading-[.98] tracking-[-.04em]">
          It all starts with a conversation.
        </h2>

        <div className="grid">
          {PROCESS.map((step, index) => {
            const isActive = index === active;
            return (
              <button
                key={step.num}
                type="button"
                aria-pressed={isActive}
                onClick={() => setActive(index)}
                onMouseEnter={() => setActive(index)}
                onFocus={() => setActive(index)}
                className={cn(
                  "grid cursor-pointer grid-cols-1 items-baseline gap-[clamp(16px,3vw,48px)] border-t py-[clamp(26px,3vw,42px)] text-left transition-colors duration-[400ms] md:grid-cols-[74px_minmax(0,1fr)_minmax(0,1.1fr)]",
                  isActive ? "border-mint" : "border-white/[.14]"
                )}
              >
                <div
                  className={cn(
                    "dc-mono text-[13px] tracking-[.18em] transition-colors duration-[400ms]",
                    isActive ? "text-mint" : "text-mist-4"
                  )}
                >
                  {step.num}
                </div>
                <h3
                  className={cn(
                    "m-0 text-[clamp(20px,2.4vw,36px)] font-semibold leading-[1.1] tracking-[-.028em] text-balance transition-colors duration-[400ms]",
                    isActive ? "text-paper" : "text-mist-6"
                  )}
                >
                  {step.title}
                </h3>
                <p
                  className={cn(
                    "m-0 text-[15px] leading-[1.75] transition-colors duration-[400ms]",
                    isActive ? "text-mist-2" : "text-mist-4"
                  )}
                >
                  {step.body}
                </p>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
